import { WebInput } from "../../../common/ui/input.web";
import clsx from "clsx";

interface TimeInputProps {
  time: string | null;
  setTime: (time: string) => void;
  nextDay?: boolean;
  showInvalid?: boolean;
  disabled?: boolean;
  className?: string;
  min?: string;
  max?: string;
}

export default function TimeInput({
  time,
  setTime,
  nextDay = false,
  showInvalid = false,
  disabled = false,
  className,
  min,
  max,
}: TimeInputProps) {
  return (
    <WebInput
      type="time"
      value={time || ""}
      onChange={(e) => setTime(e.target.value)}
      className={clsx(
        "h-10 w-24 text-center",
        showInvalid && "border-red-500",
        className
      )}
      aria-invalid={showInvalid}
      disabled={disabled}
      min={min}
      max={max}
    />
  );
}
